declare global {
  interface Window {
    clarity: any;
  }
}

const useClarityEvent = () => {
  const trackEvent = (eventName: string) => {
    if (window.clarity) {
      window.clarity('event', eventName);
    }
  };

  const identifyUser = (userId: string | number) => {
    if (window.clarity) {
      window.clarity('identify', userId.toString());
    }
  };

  return {
    trackEvent,
    identifyUser
  };
};

export default useClarityEvent; 